import { LoadingButton } from "@mui/lab";
import { Button, Stack } from "@mui/material";
import React from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";

const SaveButton = ({ loading, id, type, deleteData }) => {
  const navigate = useNavigate();

  return (
    <Stack
      spacing={2}
      mt={3}
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
    >
      <LoadingButton
        type="submit"
        sx={{
          backgroundColor: "#8A63A9",
            color: "white",
            ":hover": {
              backgroundColor: "#7A52A4",
              color: "white", 
            },
        }}
        variant="contained"
        loading={loading}
        startIcon={<Icon icon="fa-solid:save" />}
      >
        {id ? "Update" : "Add"}
      </LoadingButton>
      <Button
        type="button"
        sx={{
          backgroundColor: "#8A63A9",
            color: "white",
            ":hover": {
              backgroundColor: "#7A52A4",
              color: "white", 
            },
        }}
        onClick={() => navigate(-1)}
      >
        Cancel
      </Button>
      {type === "delete" ? (
        <Button
          sx={{
            backgroundColor: "#8A63A9",
            color: "white",
            ":hover": {
              backgroundColor: "#7A52A4",
              color: "white", 
            },
          }}
          type="button"
          onClick={() => deleteData(id)}
        >
          Delete
        </Button>
      ) : null}
    </Stack>
  );
};

export default SaveButton;
